import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { BrushIcon, PaperclipIcon } from '../components/Brand/Icon';
import './ImageMenu.scss';

export default function ImageMenu({ anchor, onDraw, onUpload, onClose }) {
  const { t } = useTranslation();
  const panel = useRef(null);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  useLayoutEffect(() => {
    const place = () => {
      const box = anchor.getBoundingClientRect();
      const view = window.visualViewport;
      const left = view?.offsetLeft || 0;
      const top = view?.offsetTop || 0;
      setPosition({ left: Math.max(left + 8, Math.min(box.left + box.width / 2 - 56,
        left + (view?.width || window.innerWidth) - 120)), top: Math.max(top + 8, box.top - 64) });
    };
    place();
    panel.current?.querySelector('button')?.focus({ preventScroll: true });
    window.addEventListener('resize', place);
    window.visualViewport?.addEventListener('resize', place);
    return () => {
      window.removeEventListener('resize', place);
      window.visualViewport?.removeEventListener('resize', place);
      if (anchor.isConnected) anchor.focus({ preventScroll: true });
    };
  }, [anchor]);
  return createPortal(<div className="image-menu-layer" onClick={event => {
    // Keep the backdrop through release so the same gesture cannot land on
    // an editor action revealed underneath it.
    if (event.target === event.currentTarget) { event.preventDefault(); event.stopPropagation(); onClose(); }
  }} onKeyDown={event => {
    if (event.key === 'Escape') { event.preventDefault(); onClose(); }
    if (['Tab', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
      const buttons = [...panel.current.querySelectorAll('button')];
      buttons[(buttons.indexOf(document.activeElement) + 1) % buttons.length]?.focus();
    }
  }}>
    <div ref={panel} className="image-menu" role="menu" aria-label={t('drawing:imageMenu')} style={position}>
      <button type="button" role="menuitem" aria-label={t('drawing:upload')} onClick={onUpload}><PaperclipIcon /></button>
      <button type="button" role="menuitem" aria-label={t('drawing:draw')} onClick={onDraw}><BrushIcon /></button>
    </div>
  </div>, document.body);
}
